// extracted by mini-css-extract-plugin
module.exports = {"WidgetWrapper":"WidgetWrapper--31yC9","Options":"Options--UbHyr","Wrapper":"Wrapper--2Q2TA","Chart":"Chart--qvWaB","MetricName":"MetricName--3Q0Cp"};